/* eslint-disable */
/* FIXME */
export interface DynamicDefaultProps<PropsType> {
    [index: string]: Partial<PropsType>;
}

// Object type extension is valid here for spreadability of generic PropsType type
// tslint:disable-next-line:ban-types
export function composeDefaultProps<PropsType extends Object, KeyType extends keyof PropsType>(
    props: PropsType,
    key: KeyType,
    dynamicDefaultProps: DynamicDefaultProps<PropsType>
): Partial<PropsType> {
    // These casts are valid here because a string cannot be compared with the generic value of the PropsType accessed by the given KeyType
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const dynamicDefaultPropKeys = Object.keys(dynamicDefaultProps) as any as any[];
    for (const propKey of dynamicDefaultPropKeys) {
        if (props[key] === propKey) {
            return dynamicDefaultProps[propKey];
        }
    }
    return {};
}
